import { SyncManager } from 'db';
import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import { useField } from 'react-final-form';

export const useVideoUpload = (sectionId: string) => {
  const vehicleId = useFormVehicleId();

  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const { input: videoInput } = useField(`${sectionId}.video`);

  return async (video: Blob[]) => {
    if (!vehicleId) return;
    const syncManager = SyncManager.getInstance(vehicleId);
    await syncManager.queueVideoUpload(serverId, video);
    videoInput.onChange(video);
  };
};
